import React from "react";
import { Props } from "./types";

function StrategicAxesIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 22.414 22.414">
      <path
        d="M13.207,2A11.207,11.207,0,1,0,24.414,13.207a10.953,10.953,0,0,0-.684-3.8L21.937,11.2a8.684,8.684,0,0,1,.235,2.006,8.966,8.966,0,1,1-8.966-8.966,8.684,8.684,0,0,1,2.006.235l1.8-1.8A11.321,11.321,0,0,0,13.207,2m7.845,0L16.569,6.483V8.164l-2.858,2.858a1.551,1.551,0,0,0-.5-.056,2.241,2.241,0,1,0,2.241,2.241,1.551,1.551,0,0,0-.056-.5L18.25,9.845h1.681l4.483-4.483H21.052V2M13.207,6.483a6.724,6.724,0,1,0,6.724,6.724H17.69a4.483,4.483,0,1,1-4.483-4.483Z"
        transform="translate(-2 -2)"
      />
    </svg>
  );
}

export { StrategicAxesIcon };
